/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.0.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DbbgZusammengefalteteEinsatzzeit } from './DbbgZusammengefalteteEinsatzzeit';
import {
    DbbgZusammengefalteteEinsatzzeitFromJSON,
    DbbgZusammengefalteteEinsatzzeitFromJSONTyped,
    DbbgZusammengefalteteEinsatzzeitToJSON,
} from './DbbgZusammengefalteteEinsatzzeit';
import type { Rechnungsposition } from './Rechnungsposition';
import {
    RechnungspositionFromJSON,
    RechnungspositionFromJSONTyped,
    RechnungspositionToJSON,
} from './Rechnungsposition';

/**
 * 
 * @export
 * @interface DbbgRechnungPositionenVorschau200Response
 */
export interface DbbgRechnungPositionenVorschau200Response {
    /**
     * 
     * @type {Array<DbbgZusammengefalteteEinsatzzeit>}
     * @memberof DbbgRechnungPositionenVorschau200Response
     */
    times: Array<DbbgZusammengefalteteEinsatzzeit>;
    /**
     * 
     * @type {Array<Rechnungsposition>}
     * @memberof DbbgRechnungPositionenVorschau200Response
     */
    invoicePositions: Array<Rechnungsposition>;
}

/**
 * Check if a given object implements the DbbgRechnungPositionenVorschau200Response interface.
 */
export function instanceOfDbbgRechnungPositionenVorschau200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "times" in value;
    isInstance = isInstance && "invoicePositions" in value;

    return isInstance;
}

export function DbbgRechnungPositionenVorschau200ResponseFromJSON(json: any): DbbgRechnungPositionenVorschau200Response {
    return DbbgRechnungPositionenVorschau200ResponseFromJSONTyped(json, false);
}

export function DbbgRechnungPositionenVorschau200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DbbgRechnungPositionenVorschau200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'times': ((json['times'] as Array<any>).map(DbbgZusammengefalteteEinsatzzeitFromJSON)),
        'invoicePositions': ((json['invoicePositions'] as Array<any>).map(RechnungspositionFromJSON)),
    };
}

export function DbbgRechnungPositionenVorschau200ResponseToJSON(value?: DbbgRechnungPositionenVorschau200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'times': ((value.times as Array<any>).map(DbbgZusammengefalteteEinsatzzeitToJSON)),
        'invoicePositions': ((value.invoicePositions as Array<any>).map(RechnungspositionToJSON)),
    };
}

